import React from 'react';
import cx from 'classnames';

import Icon from '../../atoms/Icon';
import Text from '../../atoms/Text';

import styles from './DropDownItem.module.scss';
import usePresenter from './DropDownItem.presenter';
import getProps from './DropDownItem.props';
import { DropDownItemCombinedProps } from './types';


const DropDownItem: React.FC<DropDownItemCombinedProps> = (props) => {
  const {
    type,
    state,
    className,
    classes,
    disabled,
    buttonType,
    buttonForm,
    onClick,
    icon,
    text,
    onMouseDown, // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = `${type}${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`dropDownItem${variantName}`];

  let componentView;

  switch (variantName) {
    case 'CriticalIconTextUnselected':
    case 'DefaultIconTextSelected':
    case 'DefaultIconTextUnselected': {
      componentView = (
        <button
          className={cx(currentStyle, className)}
          role={'menu'}
          disabled={disabled}
          type={buttonType}
          form={buttonForm}
          onClick={onClick}
          onMouseDown={onMouseDown} // MANUAL OVERRIDE
        >
          <Icon
            className={cx(styles.icon, classes?.icon)}
            {...internalProps.icon}
            {...icon}
          />
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}
          />
        </button>
      );
      break;
    }
    case 'DefaultTextSelected':
    case 'DefaultTextUnselected':
    case 'DefaultTextIconUnselected': { // MANUAL OVERRIDE
      componentView = (
        <button
          className={cx(currentStyle, className)}
          role={'menu'}
          disabled={disabled}
          type={buttonType}
          form={buttonForm}
          onClick={onClick}
          onMouseDown={onMouseDown} // MANUAL OVERRIDE
        >
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}
          />
        </button>
      );
      break;
    }
    // MANUAL OVERRIDE
    case 'DefaultTextIconSelected': {
      componentView = (
        <button
          className={cx(currentStyle, className)}
          role={'menu'}
          disabled={disabled}
          type={buttonType}
          form={buttonForm}
          onClick={onClick}
          onMouseDown={onMouseDown} // MANUAL OVERRIDE
        >
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}
          />
          <Icon
            className={cx(styles.icon, classes?.icon)}
            {...internalProps.icon}
            {...icon}
          />
        </button>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default DropDownItem;
